
import { Component } from "vue-property-decorator";
import { ProjectView } from "@/views/project-view";
import { ObjectHelper, QuickHelper } from "@root/core";

@Component
export default class extends ProjectView {
    /// base
    quick = this.quicks().PromotionCode;

    filterKind = "all";

    get ObjectHelper() {
        return ObjectHelper;
    }
    get QuickHelper() {
        return QuickHelper;
    }

    get tableParams() {
        const where: Record<string, any> = {};
        if (this.filterKind !== "all") {
            where.kind = this.filterKind;
        }
        return {
            where,
            orderBy: [{ createdAt: "desc" }],
        };
    }
}
